import React, { useEffect } from "react";
import { Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LandingPage from "./pages/LandingPage";
import ProgramCV from "./pages/program/cv";
import ProgramCoverLetter from "./pages/program/cover-letter";
import ProgramPersonalStatement from "./pages/program/personal-statement"
import ProgramLinkedIn from "./pages/program/linkedin";
import ProgramResumeTemplate from "./pages/program/resume-template";
import AboutResults from "./pages/about/results";
import AboutTestimonials from "./pages/about/testimonials";
import FAQ from "./pages/faq";
import { analytics } from "./analytics";
import ServicePage from "./pages/service/servicePage";
import { HashRouter as Router } from "react-router-dom";
import CheckService from "./pages/service/checkService";
import PaymentPage from "./pages/PaymentPage";
import LanguageLayout from "./components/LanguageLayout";
import IntakePage from "./pages/intake/IntakePage";
import PresalePage from "./pages/presale/PresalePage";
import ResourcesPage from "./pages/resources/ResourcesPage";
import DownloadFormPage from "./pages/resources/DownloadFormPage";
import ReviewFormPage from "./pages/ReviewFormPage";

const GAListener: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    analytics.page(location.pathname + location.search);
  }, [location]);

  return <>{children}</>;
};

const MainLayout: React.FC = () => (
  <>
    <Navbar />
    <div className="flex flex-col min-h-screen pt-20">
      <div className="flex-1 flex flex-col">
        <Outlet />
      </div>
      <Footer />
    </div>
  </>
);

const App: React.FC = () => {
  useEffect(() => {
    analytics.init();
  }, []);

  return (
    <Router>
      <GAListener>
        <Routes>
          {/* Standalone pages — no Navbar/Footer */}
          <Route path="/presale" element={<PresalePage />} />

          {/* Main layout — Navbar + Footer */}
          <Route element={<MainLayout />}>
            <Route path="/" element={<Navigate to="/ko" replace />} />
            <Route path="/:lang/*" element={<LanguageLayout />} />
            <Route index element={<LandingPage />} />
            <Route path="/service" element={<ServicePage />} />
            <Route path="/check-service" element={<CheckService />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/program/cv" element={<ProgramCV />} />
            <Route path="/program/cover-letter" element={<ProgramCoverLetter />} />
            <Route path="/program/personal-statement" element={<ProgramPersonalStatement />} />
            <Route path="/program/linkedin" element={<ProgramLinkedIn />} />
            <Route path="/program/resume-template" element={<ProgramResumeTemplate />} />
            <Route path="/about/results" element={<AboutResults />} />
            <Route path="/about/testimonials" element={<AboutTestimonials />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/intake" element={<IntakePage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/download" element={<DownloadFormPage />} />
            <Route path="/review" element={<ReviewFormPage />} />
          </Route>
        </Routes>
      </GAListener>
    </Router>
  );
};

export default App;
